module.exports = __webpack_public_path__ + "img/image-yourlogohere-white.9d463368.png";